<template>
  <div>
    <div class="max-w-screen-xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">

      <div class="mt-8">
        <p class="text-center text-base leading-6 text-gray-400">
          &copy; 2020 Getpersonal, Inc. All rights reserved. |
          <a href="mailto: help@getpersonal.io"> help@getpersonal.io</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
